<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    {{ $route.meta.title }}
                    <el-button class="title_btn" @click="openCreate()" type="primary">등록</el-button>
                </div>
                <div class="info_text mb20">
                    배너 이미지는 624 X 512 사이즈에 최적화 되어 있습니다. <br>
                    삭제시 해당 배너가 바로 삭제됩니다.
                </div>
                <div>
                        <banner-list-component :bannerType="'popup'"></banner-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
      <popup-banner-create-modal></popup-banner-create-modal>
        <popup-banner-update-modal></popup-banner-update-modal>
    </div>
</template>

<script>

import BannerListComponent from "@/components/banner/BannerListComponent";
import PopupBannerCreateModal from "@/components/modal/PopupBannerCreateModal.vue";
import PopupBannerUpdateModal from "@/components/modal/PopupBannerUpdateModal.vue";
export default {
    name: "PopupBanner",
    mixins: [],
    components: {
        BannerListComponent,
        PopupBannerCreateModal,
        PopupBannerUpdateModal
    },
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        openCreate(){
            this.$modal.show('popup-banner-create-modal')
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
